import { BOGeneralValues } from "./BOGeneralValues.model";

export class BOOrganDonor extends BOGeneralValues{
    id:number;
    organDonorAnswer:string;
    organDonorDocumentDate?:Date | undefined;
}